const CUSTOM_EVENT_NAME = 'externalApiEvent';

export function sendAppCommand(methodName, param, callback) {
  const event = new CustomEvent(CUSTOM_EVENT_NAME, {
    detail: {
      methodName,
      param,
      callback,
    },
  });

  window.dispatchEvent(event);
}

export function getCustomEventName() {
  return CUSTOM_EVENT_NAME;
}
